export const SET_UI_FLAG = 'SET_UI_FLAG';
export const SET_CONVERSATIONS = 'SET_CONVERSATIONS';
export const UPDATE_CONVERSATION = 'UPDATE_CONVERSATION';
export const ADD_CONVERSATION = 'ADD_CONVERSATION';
export const REMOVE_CONVERSATION = 'REMOVE_CONVERSATION';
export const SET_MESSAGES = 'SET_MESSAGES';
export const ADD_MESSAGE = 'ADD_MESSAGE';
export const UPDATE_MESSAGE = 'UPDATE_MESSAGE';
export const REMOVE_MESSAGE = 'REMOVE_MESSAGE';
export const SET_SUPERVISED_CONVERSATIONS = 'SET_SUPERVISED_CONVERSATIONS';
export const SET_SUPERVISED_USER = 'SET_SUPERVISED_USER';
